<template>
  <div>
    <loader :loader="sending" />
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      :search="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
    >
      <template v-slot:[`item.appointmentStartTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.appointmentStartTime) }}
      </template>
      <template v-slot:[`item.attentionDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.attentionDate) }}
      </template>
      <template v-slot:[`item.medicalPracticeRegistrationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.medicalPracticeRegistrationDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon small 
              @click="isViewDetailsTable(item.idMedicalPractice)"
              :disabled="item.statusMedicalPractice == 4"
            >
              <v-icon color="blue" v-bind="attrs" v-on="on">
                mdi-information-variant
              </v-icon>
            </v-btn>
          </template>
          <span>{{
            item.statusMedicalPractice == 3
              ? "Ver información de consulta"
              : "Cita cancelada"
          }}</span>
        </v-tooltip>

        <v-menu
          offset-y
          :nudge-width="200"
          :close-on-content-click="false"
          v-if="item.statusMedicalPractice == 3"
        >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn small  icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <!-- getDataEdit(item) -->
          <v-list dense>
            <v-list-item link @click="isEditableTable(item.idMedicalPractice)"
                        v-if="$utilFront.withPermission($prm.MODULE_DENTAL_EDIT_ALL)"
            >
              <v-list-item-icon>
                <v-icon color="warning"> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar consulta</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link @click="exportToPdf(item)">
              <v-list-item-icon>
                <v-icon color="error"> mdi-file-pdf-box </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Consulta dental </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              @click="exportPDFPrescription(item)"
              v-if="item.idPrescription != null"
            >
              <v-list-item-icon>
                <v-icon color="error"> mdi-file-pdf-box </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Receta médica </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-row align="baseline" justify="center" class="text-center py-4">
      <v-col>
        <export-import-btn
          texto="Exportar consultas"
          icono="export"
          color="green darken-1"
          @accion="exportDentalExcel(2)"
        />
      </v-col>
      <v-col>
        <v-btn outlined small color="error" @click="dialogProductivity = true">
          <v-icon left>mdi-file-pdf-box</v-icon> Descargar productividad
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogProductivity" max-width="600">
      <v-card>
        <loader :loader="sending" />
        <v-card-title class="">
          Descargar productividad 
         <p>
          <small>
           Listado  de pacientes atendidos por día.
          </small>
         </p>
        </v-card-title>
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-card-text>
            <v-row align="center" justify="center" class="text-center">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="Fecha"
                  rules="required"
                >
                  <vc-date-picker
                    :max-date="new Date()"
                    color="green"
                    v-model="dateProductivity"
                    is-required
                    required
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions  class="text-center justify-center">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogProductivity = false"  :disabled="sending">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="downloadProductivity()"
              :disabled="invalid || sending"
            >
              {{  sending ? 'Descargando...' : 'Aceptar'}}
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ReportPDFRequest } from "@/core/request";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "@/app/components/base/loader/Loader.vue";
import ExportImportBtn from "@/components/ExportImportBtn.vue";
import moment from "moment";
export default {
  name: "ExternalConsultationHistoryTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
    search: String,
    exportDentalExcel: Function,
    idBranchOfficeSelected: String,
  },
  components: {
    ExportImportBtn,
    ValidationObserver,
    ValidationProvider,
    Loader,
  },
  data() {
    return {
      dialogProductivity: false,
      sending: false,
      dateProductivity: new Date(),
      headers: [
        { text: "Id Consulta", value: "idMedicalPractice", align: "center" },
        { text: "Id Paciente", value: "idPatient", align: "center" },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Nombre del doctor", value: "doctor", align: "center" },
        {
          text: "Fecha y hora de atención",
          value: "attentionDate",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      sortBy: "attentionDate",
      sortDesc: true,
    };
  },
  mounted() {},
  methods: {
    isViewDetailsTable(id) {
      let isViewDetails = true;
      this.$emit("isViewDetails", isViewDetails);
      this.get(id, 3);
    },
    isEditableTable(id) {
      let isViewDetails = false;
      this.$emit("isViewDetails", isViewDetails);
      this.get(id, 3);
    },
    exportToPdf(item) {
      this.sending = true;
      if (item.idMedicalPractice) {
        const fileName = `Consulta_Dental_${item.idMedicalPractice}_${moment(
          new Date(item.attentionDate)
        ).format("YYYY-MM-DD")}`;
        // console.log(fileName);

        let data = {
          idConsultation: item.idMedicalPractice,
          idDiagnostic: item.idDiagnostic,
          fileName: fileName,
        };
        ReportPDFRequest.downloadDentalReport(data)
          .then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    exportPDFPrescription(item) {
      this.sending = true;
      let url = new URL(location.origin);
      let data = {
        idPrescription: item.idPrescription,
        url: url,
        fileName: "Receta",
      };
      ReportPDFRequest.downloadPrescription(data, this);
      // .then((response) => {
      //   const url = URL.createObjectURL(
      //     new Blob([response.data], {
      //       type: "application/pdf",
      //     })
      //   );
      //   window.open(url);
      // })
      // .catch((error) => {})
      // .finally(() => {
      //   this.sending = false;
      // });
    },
    downloadProductivity() {
      this.sending = true;
      let paramsRequest = {
        startDate: this.$utilFront.startOfDay(this.dateProductivity),
        finishDate: this.$utilFront.endOfDay(this.dateProductivity),
        idBranchOffice: this.$utilFront.nonEmpty(
          this.idBranchOfficeSelected,
          this.$utilFront.getIdBranchOffice()
        ),
      };

      ReportPDFRequest.downloadDentalPDF(paramsRequest)
        .then((response) => {
          if (
            response.status == 200 &&
            response.data.type != "application/json"
          ) {
            this.$utilFront.openPDF(response.data);
          } else {
            this.$utilFront.displayErrorPdf(response.data);
          }
        })
        .finally(() => {
          this.sending = false;
          this.dialogProductivity = false;
        });
    },
  },
};
</script>
